<jhi-alert></jhi-alert>
<div class="container mt-4">
  <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="configurazioneGeneraleService && configurazioneGeneraleService.configurazione && configurazioneGeneraleService.configurazione.backButtonIsPresent"><a (click)="goToHome()">Home</a><span class="separator">/</span></li>
      <li class="breadcrumb-item"><a (click)="goToServizi()">Servizi</a><span class="separator">/</span></li>
      <li class="breadcrumb-item active"><a href="javascript:void(0)"><span *ngIf="istanzaCorrente && istanzaCorrente.istanza">{{istanzaCorrente.istanza.descrizione}}</span></a></li>
    </ol>
  </nav>
<div class="cmp-heading pb-3 pb-lg-4">
  <div class="categoryicon-top d-flex">
    <svg class="icon icon-success mr-10 big-lg-icon mb-1" aria-hidden="true">
      <use href="./content/svg/sprites.svg#it-check-circle"></use>
    </svg>
    <h1 class="title-xxxlarge">Richiesta inviata</h1>
  </div>

  <p class="subtitle-small">Grazie, abbiamo ricevuto la tua richiesta per la pratica <strong *ngIf="istanzaCorrente && istanzaCorrente.istanza">{{istanzaCorrente.istanza.descrizione}}</strong></p>
  <p class="subtitle-small pt-3">Procedimento associato: <strong *ngIf="istanzaCorrente && istanzaCorrente.istanza">{{istanzaCorrente.istanza.protocolloAnno}}/{{istanzaCorrente.istanza.protocolloNumero}}</strong></p>
  <p class="subtitle-small">Data massima evasione: <strong *ngIf="istanzaCorrente && istanzaCorrente.istanza">{{istanzaCorrente.istanza.dataMassimaEvasione | date: 'dd/MM/yyyy'}}</strong></p>
  <p class="subtitle-small pt-3 pt-lg-4">Abbiamo inviato il riepilogo all’email specificata<br>
  <button type="button" class="btn btn-outline-primary fw-bold">
                  <span class="rounded-icon">
                    <svg class="icon icon-primary icon-sm" aria-hidden="true">
                      <use href="../assets/bootstrap-italia/dist/svg/sprites.svg#it-download"></use>
                    </svg>
                  </span>


    <span class="" (click)="downloadPdf()">{{istanzaCorrente && istanzaCorrente.istanza && istanzaCorrente.istanza.servizio && istanzaCorrente.istanza.servizio.cdServizio === 'IMU' ? 'Scarica mandati di pagamento' : 'Scarica la pratica (PDF)'}}</span>
  </button>

</div>
  <hr class="d-none d-lg-block mt-3 mb-40">
  <h2 class="title-xxlarge mb-3">Prossimi passi</h2>
  <p class="subtitle-small">Vai alla scheda servizio per vedere i prossimi passi</p>
  <p class="mt-4 mt-lg-30 mb-10"><a class="t-primary" (click)="goToDatiIstanza()" data-focus-mouse="false">Consulta la richiesta</a> nella tua area riservata.</p>
</div>

<div class="background-primary">
  <div class="pb-lg-80 pt-lg-80">
  <div class="container">
    <div class="card card-wrapper bg-white">
    <div class="row justify-content-center">
    <form class="col-auto" [formGroup]="ratingForm" *ngIf="!feedbackInviato; else inviato">
      <jhi-rating (ratingSelected)="onRatingSelected($event)"></jhi-rating>
      <div *ngIf="selectedRating > 0 && !inTextAreaPhase" class="question-container mt-5"
           [ngClass]="{'less-bright': selectedRating <= 3}">
        <jhi-question *ngIf="choices.length > 0" [question]="questionText" [choices]="choices" (choiceSelected)="handleChoiceSelected($event)"></jhi-question>
        <div class="button-container text-end mt-5">
          <button class="back-button btn btn-primary primary-button" (click)="resetSelection()">Indietro</button>
          <button class="next-button submit-button btn btn-primary primary-button" (click)="showTextArea()" [disabled]="ratingForm.get('primaRisposta')?.value === null && ratingForm.get('secondaRisposta')?.value === null">
            Avanti
          </button>
        </div>
      </div>
      <div *ngIf="inTextAreaPhase" class="question-container mt-5">
        <div class="textarea-question">
          <p>Vuoi aggiungere altri dettagli?</p>
          <textarea class="text-area" maxlength="200" formControlName="note"></textarea>
        </div>
        <div class="button-container text-end mt-5">
          <button class="back-button btn btn-primary primary-button" (click)="backToChoices()">Indietro</button>
          <button class="submit-button btn btn-primary primary-button" (click)="submitQuestion()">Invia</button>
        </div>
      </div>
    </form>
    <ng-template #inviato>
      <div class="d-flex justify-content-center mt-3">
                <span class="fw-bold">Feedback inviato
                  <svg class="icon icon-color">
                    <use href="./content/svg/sprites.svg#it-check"></use>
                  </svg>
                </span>
      </div>
    </ng-template>
  </div>
    </div>
  </div>
  </div>
</div>
